import { SliderComponent } from '@webentorCore/_slider';

document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.b-strategy-slider .js-slider');

  sliders.forEach((element) => {
    const dataSlider = element.getAttribute('data-slider');
    const params = JSON.parse(dataSlider || '{}');
    const container = element.closest(
      '.js-strategy-slider-container',
    ) as HTMLElement;

    // Initialize slider
    const sliderInstance = new SliderComponent(element, params);

    // Update progress bar based on active slide
    const updateProgressBar = () => {
      if (!(sliderInstance as any).swiper) return;

      const progressBar = container?.querySelector(
        '.js-strategy-slider-progress',
      ) as HTMLElement;
      const progressBall = container?.querySelector(
        '.js-strategy-slider-progress-ball',
      ) as HTMLElement;

      if (!progressBar || !progressBall) return;

      const swiper = (sliderInstance as any).swiper;

      // Use realIndex which works correctly with cards effect and loop mode
      // realIndex always represents the actual slide number (0-based)
      const activeIndex = swiper.realIndex;

      // Count only real slides by checking the slides array
      // For non-loop sliders, this is just slides.length
      // For loop sliders, we filter out duplicates
      const realSlides = Array.from(swiper.slides).filter(
        (slide: any) => !slide.classList.contains('swiper-slide-duplicate'),
      );
      const totalSlides = realSlides.length;

      // Calculate segment width based on number of slides
      // We need totalSlides - 1 segments to go from 0% to 100%
      const segmentWidth = 100 / (totalSlides - 1);

      // Calculate progress bar width (starts at 0 for first slide, ends at 100 for last)
      const progressWidth = activeIndex * segmentWidth;

      // Calculate ball position (at the end of current segment)
      const ballPosition = progressWidth;

      progressBar.style.width = `${progressWidth}%`;
      progressBall.style.left = `${ballPosition}%`;
    };

    // Manual navigation handlers
    const setupNavigation = () => {
      const nextBtn = container?.querySelector(
        '.js-strategy-slider-button-next',
      );
      const prevBtn = container?.querySelector(
        '.js-strategy-slider-button-prev',
      );

      nextBtn?.addEventListener('click', () => {
        if ((sliderInstance as any).swiper) {
          (sliderInstance as any).swiper.slideNext();
        }
      });

      prevBtn?.addEventListener('click', () => {
        if ((sliderInstance as any).swiper) {
          (sliderInstance as any).swiper.slidePrev();
        }
      });
    };

    // Initialize everything
    const init = () => {
      // Use setTimeout to ensure Swiper has fully initialized
      setTimeout(() => {
        updateProgressBar();
      }, 100);
    };

    // Setup event handlers
    if ((sliderInstance as any).swiper) {
      const swiper = (sliderInstance as any).swiper;

      swiper.on('init', init);

      // Listen to slideChange for progress bar updates only
      swiper.on('slideChange', () => {
        updateProgressBar();
      });

      init();
      setupNavigation();
    }
  });
});
